import * as React from "react"
import Loadable from "@loadable/component";

const LoginComponent = Loadable(() => import('../components/Login'))

const IndexPage = ({ location }: { location: any }) => {
    return <LoginComponent location={location}/>;
}

export default IndexPage;
